// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.single-sign-on__identity-provider {
    margin-bottom: calc(1.5rem);
    white-space: normal;
  }

    .single-sign-on__identity-provider:last-of-type {
      margin-bottom: calc(.5rem);
    }
`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
